import Button from '@jusbrasil-rc/button'
import classNames from 'classnames'

import { ShowMoreTextButtonProps } from '../../unstyled-components'

export function ShowMoreTextButtonMystique(props: ShowMoreTextButtonProps) {
  const { toggle, show } = props
  return (
    <Button color="blue" isFlat isRightIcon onClick={toggle}>
      {show ? 'Mostrar menos' : 'Mostrar mais'}
      <span
        className={classNames('icon', {
          'icon-chevron-down': !show,
          'icon-chevron-up': show,
        })}
      />
    </Button>
  )
}
